import React from "react";

// Local
import styled from "@emotion/styled";

const Circle = styled.circle`
  -webkit-transition: all -webkit-transform 0.5s;
  transition: all 0.5s;
`;

const CountryDot = props => {
  return (
    <Circle
      cx={props.cx}
      cy={props.cy}
      r={props.r}
      fill={props.fill}
      opacity={props.opacity}
      stroke={props.stroke}
      strokeWidth={props.strokeWidth}
    />
  );
};

export default CountryDot;
